export enum FeatureFlags {
  AccountExecutives = 'ACCOUNT_EXECUTIVES',
  Activities = 'ACTIVITIES_PAGE',
  Amplitude = 'AMPLITUDE',
  AmsProducerCodes = 'AMS_PRODUCER_CODES',
  AlliantCarrierReport = 'ALLIANT_CARRIER_REPORT',
  AnnualizedValues = 'ANNUALIZED_VALUES',
  BizOrgColumnForAccountTable = 'BIZ_ORG_FOR_ACCOUNTS_TABLE',
  BizOrgsByCarrierPremiumColumn = 'BIZ_ORGS_BY_CARRIER_PREMIUM_COLUMN',
  BizOrgsByCarrierRevenueColumn = 'BIZ_ORGS_BY_CARRIER_REVENUE_COLUMN',
  CarrierAppetiteCommunityTab = 'CARRIER_APPETITE_COMMUNITY_TAB',
  ClientTagsFilter = 'CLIENT_TAGS_FILTER',
  CompanySearchCountrySelect = 'COMPANY_SEARCH_COUNTRY_SELECT',
  CrossSellProspects = 'CROSS_SELL_PROSPECTS',
  CustomHomePage = 'CUSTOM_HOME_PAGE',
  DisableDecisions = 'DISABLE_DECISIONS',
  EnnablAi = 'ENNABL_AI',
  KingInsuranceGrowthCustomUI = 'KING_INSURANCE_GROWTH_CUSTOM_UI',
  LifetimeValueSection = 'LIFETIME_VALUE_SECTION',
  O360Score = 'O360_SCORE',
  PolicyStatusFilter = 'POLICY_STATUS_FILTER',
  PolicyTagsFilter = 'POLICY_TAGS_FILTER',
  PolicySourceCodes = 'POLICY_SOURCE_CODES',
  PrivacyPolicyPage = 'PRIVACY_POLICY_PAGE',
  ProducerViewWithCarrierAppetite = 'PRODUCER_VIEW_WITH_CARRIER_APPETITE',
  Retention = 'RETENTION_PAGE',
  RenewalStage = 'RENEWAL_STAGE',
  SourceDataManagement = 'SOURCE_DATA_MANAGEMENT',
  UserAgreementGate = 'USER_AGREEMENT_GATE',
  UnisonTenant = 'UNISON_TENANT',
  UserManagement = 'USER_MANAGEMENT',
  SubAdminPermissions = 'SUB_ADMIN_PERMISSIONS',
  MGADashboard = 'MGA_DASHBOARD',
  MonolineRatios = 'MONOLINE_RATIOS',
  InteractionHints = 'INTERACTION_HINTS',
  Intercom = 'INTERCOM',
  WhatsNew = 'WHATS_NEW_PAGE',
  PostHog = 'POST_HOG',
  // Workflows
  WorkflowsSharing = 'WORKFLOWS_SHARING',
  WorkflowsWriteBack = 'WORKFLOWS_WRITE_BACK',
  DocsLibrary = 'DOCS_LIBRARY',
  DocsCompare = 'DOCS_COMPARE',
  ProposalGeneration = 'PROPOSAL_GENERATION',
  SoiGeneration = 'SOI_GENERATION',
  LossRuns = 'LOSS_RUNS',
  AmsDocuments = 'AMS_DOCUMENTS',
  AmsAudit = 'AMS_AUDIT',
  SubmissionGeneration = 'SUBMISSION_GENERATION',
  WorkflowsDemoMode = 'WORKFLOWS_DEMO_MODE',
  AcordPrefill = 'ACORD_PREFILL',
}

export enum FeatureFlagsGroup {
  Workflows = 'WORKFLOWS',
}
